export function deemphasiseText(text) {
    const formattedText = text.split('##').join('');
    return formattedText;
}
